import * as React from 'react'
import { deviceTypes } from './operationsModel'

const equipmentImages = { 'portable-ac': 'portable-ac', dehumidifier: 'dehumidifier', jetwash: 'jet-washer', 'fan-heater': 'fan-heater' }

export function EquipmentStack({ productType, quantity, unitCodes }: { productType?: string | null; quantity: number; unitCodes?: string[] }) {
  const name = deviceTypes.find(type => type.value === productType)?.label || 'Equipment'
  const image = productType && Object.hasOwn(equipmentImages, productType) ? equipmentImages[productType as keyof typeof equipmentImages] : undefined
  const count = Math.max(1, quantity)
  const step = count > 1 ? Math.min(10, 32 / (count - 1)) : 0
  return <div className="bookings-equipment" title={unitCodes ? unitCodes.join(', ') || 'Not assigned' : undefined}>
    {image && <div className="bookings-equipment-stack" role="img" aria-label={quantity ? `${quantity} ${name.toLowerCase()}` : name} style={{ width: 44 + (count - 1) * step }}>
      {Array.from({ length: count }, (_, index) => <img key={index} src={`/equipment-icons/${image}.png`} alt="" aria-hidden="true" width="44" height="54" style={{ left: index * step, top: (index % 3) * 2, zIndex: index }} />)}
    </div>}
    <small>{quantity ? `${quantity} ${quantity === 1 ? 'unit' : 'units'}` : 'Not assigned'}</small>
  </div>
}

